﻿
$(document).ready(function () {

    function getUniqueId(str) {
        return str.split("Modal")[1];
    }

    var imageGalleries = $(".image-gallery");

    imageGalleries.each(function () {
        var modalGallery = $(this).siblings(".image-gallery-modal");
        var fullScreenButton = $(this).find('.carousel-control-fullscreen');

        var imageGalleryClone = $(this).clone();

        fullScreenButton.one('click', function () {
            imageGalleryClone.find('.carousel-item img').addClass("lazypreload");
        });

        modalGallery.append(imageGalleryClone);
        var modalGalleryUniqueID = getUniqueId(modalGallery.attr("id"));

        var imageGalleryInModal = modalGallery.find(".image-gallery");
        imageGalleryInModal.attr("id", ("imageGalleryInModal" + modalGalleryUniqueID));

        var images = imageGalleryInModal.find(".carousel-image");
        images.siblings("source").remove();

        //imageGalleryInModal.find(".carousel-indicators button").hide();
        modalGallery.find(".carousel-control-prev")
            .attr("href", "#imageGalleryInModal" + modalGalleryUniqueID);
        modalGallery.find(".carousel-control-next")
            .attr("href", "#imageGalleryInModal" + modalGalleryUniqueID);
        imageGalleryInModal.find(".carousel-control-fullscreen").remove();
        imageGalleryInModal.find(".carousel-indicators").remove();
        imageGalleryInModal.find(".carousel-nav").remove();
        
        $(this).next(".modal").appendTo('body');
    });

    $(".carousel-control-fullscreen").click(function () {
        let modal = $(this).attr("data-target");
        let gallery = $(this).parent().parent();
        let index = $(gallery).find(".carousel-inner .carousel-item.active").index();

        $(modal).find(".carousel-item").removeClass("active");
        $(modal).find(".carousel-item").eq(index).addClass("active");
    });

});